import { render, staticRenderFns } from "./HabitsDash.vue?vue&type=template&id=3b7c96cf&scoped=true&"
import script from "./HabitsDash.vue?vue&type=script&lang=js&"
export * from "./HabitsDash.vue?vue&type=script&lang=js&"
import style0 from "./HabitsDash.vue?vue&type=style&index=0&id=3b7c96cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7c96cf",
  null
  
)

export default component.exports